import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import {
  createProviderReport,
  getAdminProviderReports,
  getMyProviderReports,
  updateProviderReportStatus,
} from './provider-reports.api';
import type { ProviderReportFormValues, ProviderReportStatus } from './provider-reports.dto';

export const useMyProviderReportsQuery = (serviceProviderId?: string, enabled = true) =>
  useQuery({
    queryKey: ['provider-reports', 'mine', serviceProviderId],
    queryFn: () => getMyProviderReports(serviceProviderId!),
    enabled: enabled && !!serviceProviderId,
  });

export const useAdminProviderReportsQuery = (serviceProviderId?: string, enabled = true) =>
  useQuery({
    queryKey: ['provider-reports', 'admin', serviceProviderId],
    queryFn: () => getAdminProviderReports(serviceProviderId!),
    enabled: enabled && !!serviceProviderId,
  });

export const useCreateProviderReportMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      serviceProviderId,
      values,
    }: {
      serviceProviderId: string;
      values: ProviderReportFormValues;
    }) => createProviderReport(serviceProviderId, values),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['provider-reports'] }),
  });
};

export const useUpdateProviderReportStatusMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ reportId, status }: { reportId: string; status: ProviderReportStatus }) =>
      updateProviderReportStatus(reportId, status),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['provider-reports'] }),
  });
};
